import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const temperature_IN: typeof valueTypeRenderers.temperature_IN = {
  label: () => unitConverter.temperatureInCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.temperatureInCanopy().title(),
      render: (n) => unitConverter.temperatureInCanopy(n).valueAsString(),
    }),
}
